// extracted by mini-css-extract-plugin
module.exports = {"pintxo-pagination-dots":"PaginationDots_pintxo-pagination-dots__4oNlj","pintxo-pagination-dots__container":"PaginationDots_pintxo-pagination-dots__container__ZjEON"};